import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            热门内容分类
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            浏览 17c.cc 的各类内容，找到您最感兴趣的主题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-3 group-hover:text-accent-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-5 flex items-center gap-1 text-sm text-accent-500 font-medium">
                <span>浏览更多</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}